import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const OwnerTabSkeleton = () => (
  <div className="container-fluid p-3">
    <div className="row">
      <div className="col-12">
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>

          <div className="col-12 mb-3">
            <div className="row mb-3">
              <div className="col-4">
                <Skeleton width="100%" height={15} />
              </div>
              <div className="col-4">
                <Skeleton width="100%" height={15} />
              </div>
              <div className="col-4">
                <Skeleton width="100%" height={15} />
              </div>
            </div>
            <div className="row mb-3 d-flex justify-content-end">
              <div className="col-1">
                <Skeleton width="100%" height={25} />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-12">
                <Skeleton width="100%" height={50} />
              </div>
            </div>
            <div className="row  d-flex justify-content-end">
              <div className="col-1">
                <Skeleton width="100%" height={25} />
              </div>
              <div className="col-1">
                <Skeleton width="100%" height={25} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row mb-2">
      <div className="col-12 mb-1">
        <Skeleton height={30} width="20%" />
      </div>
      <Skeleton height={10} width="15%" />

      <div className="col-12 mb-1">
        <Skeleton height={10} width="25%" />
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-md-6">
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="80%" height={25} />
            <Skeleton height={10} width="25%" />
          </div>

          <div className="col-12 mb-3">
            <Skeleton width="100%" height={30} className="mb-1" />
          </div>

          <div className="col-12 mb-3">
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="col-12 mb-3">
          <Skeleton width="100%" height={30} className="mb-1" />
        </div>

        <div className="col-12 mb-3">
          <Skeleton width="100%" height={25} className="mb-1" />
          <Skeleton width="100%" height={25} className="mb-1" />
          <Skeleton width="100%" height={25} className="mb-1" />
          <Skeleton width="100%" height={25} className="mb-1" />
          <Skeleton width="100%" height={25} />
        </div>
      </div>

      <div className="col-12 col-md-6">
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="80%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mt-5" />
          <div className="col-12 mb-3 mt-5">
            <Skeleton width="100%" height={35} />
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={20} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3" />
          <div className="col-12 col-sm-6 col-md-4 mb-3" />

          <div className="col-12  mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12  mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} className="mb-1" />
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-6 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-6 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={20} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

// No props needed here, as this is a static skeleton mimicking your UI

export default OwnerTabSkeleton;
